<template>
  <div class="vx-row">
  </div>
</template>
<script>
import { odtHostname } from '@/environment/environment'

export default {
  onMounted() {
    window.location.href = odtHostname + "/bsg/";
  }
}
</script>